import { cultures } from '../constants/cultures';

export function getCultureDisplayName(culture) {
	switch (cultures.ar) {
		case culture:
			return 'Arabic';
		default:
			return 'English';
	}
}

export function getCultureBasedOnRegion(culture = '') {
	if (culture?.includes('ar')) {
		return 'Arabic';
	}
	return 'English';
}

export function getCultureName(locale) {
	return cultures[locale || 'en'];
}
